import { render, staticRenderFns } from "./Armada.vue?vue&type=template&id=e666f85c&"
import script from "./Armada.vue?vue&type=script&lang=js&"
export * from "./Armada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports